import React, { useState, useEffect } from "react";
import { Col, Row, Table } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./ReportClassTable.css";
import "./SencoStudentsResultsTable.css"; // Import the same CSS file for styling

import LiteracyObservationsModal from "./LiteracyObservationsModal";
import ReadingScoreNotesModal from "./ReadingScoreNotesModal";
import AdditionalNeedsModal from "./AdditionalNeedsModal";
import DetailsOfSetReceivedModal from "./DetailsOfSetReceivedModal";
import SencoSupportPlanModal from "./SencoSupportPlanModal";
import SencoAdditionalNeedsModal from "./SencoAdditionalNeedsModal";
import PlaceOnContinuumModal from "./PlaceOnContinuumModal";
import SetSencoEalModal from "./SetSencoEalModal";
import ConfirmationModal from "./ConfirmationModal";
import SetEalModal from "./SetEalModal";
import SetSetModal from "./SetSetModal";
import SetSetNameModal from "./SetSetNameModal";
import SetAttendanceAffectingScoresModal from "./SetAttendanceAffectingScoresModal";

import {
  upsertSencoReport,
  getSencoReportByStudentId,
} from "../services/APIClient";
import SencoReportTableRow from "./SencoReportTableRow";
import PriorityConcernsModal from "./PriorityConcernsModal";
import ClassroomSupportPlanModal from "./ClassroomSupportPlanModal";
import SENWatchlistTableRow from "./SENWatchlistTableRow";

function SENWatchlistTable(props) {
  const {
    students,
    showAtRiskOnly,
    setShowAtRiskOnly,
    teachers,
    teacherid,
    studentsReadingScore,
    classDetails,
    showSortedData,
    readingScores,
  } = props;

  const dummyHeaderArray = [
    "Class",
    "SET",
    "Classroom Support Plan",
    "Details Of SET Received",
    "Priority Concerns",
    "Additional Needs",
    "Support Plan",
    "EAL",
    "Place on Continuum",
  ];

  useEffect(() => {
    setCallClassName("");
  });

  const [callClassName, setCallClassName] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("all");

  const handleFilterChange = (e) => {
    setSelectedFilter(e.target.value);
  };

  const [showLiteracyModal, setShowLiteracyModal] = useState(false);
  const [showReadingScoreModal, setShowReadingScoreModal] = useState(false);
  const [showAdditionalNeedsModal, setShowAdditionalNeedsModal] =
    useState(false);
  const [showSupportPlanModal, setShowSupportPlanModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showEalModal, setShowEalModal] = useState(false);
  const [showSetModal, setShowSetModal] = useState(false);
  const [
    showAttendanceAffectingScoresModal,
    setShowAttendanceAffectingScoresModal,
  ] = useState(false);

  const [showDetailsOfSetReceivedModal, setShowDetailsOfSetReceivedModal] =
    useState(false);

  const [showPlaceOnContinuumModal, setShowPlaceOnContinuumModal] =
    useState(false);

  const [showPriorityConcernsModal, setShowPriorityConcernsModal] =
    useState(false);

  const [showSencoSupportPlanModal, setShowSencoSupportPlanModal] =
    useState(false);

  const [showClassroomSupportPlanModal, setShowClassroomSupportPlanModal] =
    useState(false);

  const [showSencoAdditionalNeedsModal, setShowSencoAdditionalNeedsModal] =
    useState(false);

  const [showSetSetNameModal, setShowSetSetNameModal] = useState(false);

  const [showSencoEalModal, setShowSencoEalModal] = useState(false);

  const [currentStudentName, setCurrentStudentName] = useState("");
  const [currentStudentId, setCurrentStudentId] = useState("");

  // State to hold selections
  const [readingScoreNotes, setReadingScoreNotes] = useState([]);
  const [literacyObservations, setLiteracyObservations] = useState("");
  const [additionalNeeds, setAdditionalNeeds] = useState([]);
  const [setReceived, setSetReceived] = useState([]);
  const [priorityConcerns, setPriorityConcerns] = useState([]);
  const [sencoSupportPlan, setSencoSupportPlan] = useState([]);
  const [placeOnContinuum, setPlaceOnContinuum] = useState([]);
  const [classroomSupportPlan, setClassroomSupportPlan] = useState(false);
  const [sencoAdditionalNeeds, setSencoAdditionalNeeds] = useState([]);
  const [sencoEal, setSencoEal] = useState(false);
  const [eal, setEal] = useState(false);
  const [set, setSet] = useState(false);
  const [setName, setSetName] = useState("");
  const [attendanceAffectingScores, setAttendanceAffectingScores] =
    useState(false);

  const [sortCriteria, setSortCriteria] = useState({
    field: "name",
    order: "asc",
  });
  const [sortedData, setSortedData] = useState([]);

  const handleShowLiteracyModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowLiteracyModal(true);
  };

  const handleShowReadingScoreModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);

    setShowReadingScoreModal(true);
  };

  const handleShowAdditionalNeedsModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowAdditionalNeedsModal(true);
  };

  const handleShowSencoAdditionalNeedsModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSencoAdditionalNeedsModal(true);
  };

  const handleShowClassroomSupportPlanModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowClassroomSupportPlanModal(true);
  };

  const handleShowDetailsOfSetReceivedModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);

    setShowDetailsOfSetReceivedModal(true);
  };

  const handleShowPlaceOnContinuumModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);

    setShowPlaceOnContinuumModal(true);
  };

  const handleShowAttendanceAffectingScoresModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowAttendanceAffectingScoresModal(true);
  };

  const handleShowESetModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSetModal(true);
  };

  const handleShowEalModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowEalModal(true);
  };

  const handleShowSencoEalModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSencoEalModal(true);
  };

  const handleShowPriorityConcernsModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowPriorityConcernsModal(true);
  };

  const handleShowSencoSupportPlanModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSencoSupportPlanModal(true);
  };

  const handleShowSetSetNameModal = (studentName, studentId) => {
    setCurrentStudentName(studentName);
    setCurrentStudentId(studentId);
    setShowSetSetNameModal(true);
  };

  const bumpDataVersion = () => setTimeout(() => setDataVersion((v) => v + 1), 300);
  const handleCloseLiteracyModal = () => { setShowLiteracyModal(false); bumpDataVersion(); };
  const handleCloseReadingScoreModal = () => { setShowReadingScoreModal(false); bumpDataVersion(); };
  const handleCloseAdditionalNeedsModal = () => { setShowAdditionalNeedsModal(false); bumpDataVersion(); };
  const handleCloseSupportPlanModal = () => { setShowSupportPlanModal(false); bumpDataVersion(); };
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);
  const handleCloseEalModal = () => { setShowEalModal(false); bumpDataVersion(); };
  const handleCloseSetModal = () => { setShowSetModal(false); bumpDataVersion(); };
  const handleCloseAttendanceAffectingScoresModal = () => { setShowAttendanceAffectingScoresModal(false); bumpDataVersion(); };
  const handleCloseDetailsOfSetReceivedModal = () => { setShowDetailsOfSetReceivedModal(false); bumpDataVersion(); };
  const handleCloseSencoEalModal = () => { setShowSencoEalModal(false); bumpDataVersion(); };
  const handleClosePlaceOnContinuumModal = () => { setShowPlaceOnContinuumModal(false); bumpDataVersion(); };
  const handleClosePriorityConcernsModal = () => { setShowPriorityConcernsModal(false); bumpDataVersion(); };
  const handleCloseSencoSupportPlanModal = () => { setShowSencoSupportPlanModal(false); bumpDataVersion(); };
  const handleCloseClassroomSupportPlanModal = () => { setShowClassroomSupportPlanModal(false); bumpDataVersion(); };
  const handleCloseSencoAdditionalNeedsModal = () => { setShowSencoAdditionalNeedsModal(false); bumpDataVersion(); };
  const handleCloseSetSetModal = () => { setShowSetSetNameModal(false); bumpDataVersion(); };

  const [lastSavedStudentId, setLastSavedStudentId] = useState();
  const [dataVersion, setDataVersion] = useState(0);

  const initialState = {
    sencoAdditionalNeeds: [],
    sencoSupportPlan: [],
    sencoEal: false,
    classroomSupportPlan: false,
    setName: "",
    setReceived: [],
    priorityConcerns: [],
    placeOnContinuum: [],
  };

  const resetStateVariables = () => {
    if (currentStudentId !== lastSavedStudentId) {
      setSetName(initialState.setName);
      setSencoAdditionalNeeds(initialState.sencoAdditionalNeeds);
      setSencoSupportPlan(initialState.sencoSupportPlan);
      setSencoEal(initialState.sencoEal);
      setClassroomSupportPlan(initialState.classroomSupportPlan);
      setSetReceived(initialState.setReceived);
      setPriorityConcerns(initialState.priorityConcerns);
      setPlaceOnContinuum(initialState.placeOnContinuum);
    }
  };

  const handleAtRiskFilterChange = (e) => {
    setShowAtRiskOnly(e.target.checked);
  };

  const handleConfirmChange = () => {
    console.log("Confirmation received, saving changes");
    handleSaveChanges();
    handleCloseConfirmationModal();
  };

  useEffect(() => {
    if (currentStudentId) {
      getSencoReportByStudentId(currentStudentId)
        .then((response) => {
          if (response && response.readingscorenotes !== undefined) {
            setReadingScoreNotes(response.readingscorenotes);
          }
          if (response && response.literacyobservations !== undefined) {
            setLiteracyObservations(response.literacyobservations);
          }
          if (response && response.additionalneeds !== undefined) {
            setAdditionalNeeds(response.additionalneeds);
          }
          if (response && response.supportplan !== undefined) {
            // setSupportPlan(response.supportplan);
          }
          if (response && response.eal !== undefined) {
            setEal(response.eal);
          }
          if (response && response.set !== undefined) {
            setSet(response.set);
          }
          if (response && response.attendanceaffectingscores !== undefined) {
            setAttendanceAffectingScores(response.attendanceaffectingscores);
          }
        })
        .catch((error) => console.error("Error fetching JiSi report:", error));
    }
  }, [currentStudentId]);

  const handleSortChange = (field) => {
    setSortCriteria((prev) => ({
      field,
      order: prev.field === field && prev.order === "asc" ? "desc" : "asc",
    }));
  };

  const getSortIcon = (field) => {
    if (sortCriteria.field === field) {
      return sortCriteria.order === "asc"
        ? process.env.PUBLIC_URL + "/assets/imgs/desc-icon-active.png"
        : process.env.PUBLIC_URL + "/assets/imgs/asc-icon-active.png";
    }
    return process.env.PUBLIC_URL + "/assets/imgs/asc-icon-default.png";
  };

  const getReadingScoreClass = (score) => {
    if (score === 0) {
      return "low-color";
    } else if (score > 0 && score <= 20) {
      return "low-color";
    } else if (score > 20 && score <= 40) {
      return "med-color";
    } else if (score > 40 && score <= 80) {
      return "noRisk-color";
    } else if (score >= 81 && score <= 100) {
      // Include 81 in high-color
      return "high-color";
    }
    return "";
  };

  const handleSaveChanges = () => {
    const reportData = {
      studentid: currentStudentId,
      teacherid: teacherid,
      classname: callClassName,
      setname: setName,
      classroomsupportplan: classroomSupportPlan,
      setreceived: setReceived,
      priorityconcerns: priorityConcerns,
      additionalneeds: sencoAdditionalNeeds,
      supportplan: sencoSupportPlan,
      eal: sencoEal,
      supportcontinuum: placeOnContinuum,
    };

    if (currentStudentId) {
      setLastSavedStudentId(currentStudentId); // Update last saved student ID
      resetStateVariables();
      upsertSencoReport(reportData)
        .then((response) => {
          resetStateVariables();
          setDataVersion((v) => v + 1);
          console.log("Upsert SENCO Report Success:", response);
        })
        .catch((error) => console.error("Error:", error));
    } else {
      console.error("Error: No student selected.");
    }
  };

  return (
    <Row>
      <Col>
        <div>
          <Row className="mb-3 filter-row">
            {/* <Col>
              <div className="float-left-container">
                <label className="label-style">Show only:</label>
                <input
                  type="radio"
                  id="all"
                  name="filter"
                  value="all"
                  className="radio-button-style input-margin"
                  checked={selectedFilter === "all"}
                  onChange={handleFilterChange}
                />
                <label htmlFor="all" className="label-style">
                  All
                </label>

                <input
                  type="radio"
                  id="atRisk0to20"
                  name="filter"
                  value="atRisk0to20"
                  className="radio-button-style input-margin"
                  checked={selectedFilter === "atRisk0to20"}
                  onChange={handleFilterChange}
                />
                <label
                  htmlFor="atRisk0to20"
                  className="radio-label radio-label-red label-style"
                >
                  At risk 0-20%
                </label>
                <input
                  type="radio"
                  id="atRisk21to40"
                  name="filter"
                  value="atRisk21to40"
                  className="radio-button-style input-margin"
                  checked={selectedFilter === "atRisk21to40"}
                  onChange={handleFilterChange}
                />
                <label
                  htmlFor="atRisk21to40"
                  className="radio-label radio-label-yellow label-style"
                >
                  21-40%
                </label>
              </div>
            </Col> */}
          </Row>
          <div style={{ overflowX: "auto", width: "100%" }}>
            <Table className="custom-table" style={{ minWidth: 900 }}>
              <thead>
                <tr>
                  <th className="table-header-cell">
                    <div className="header-content">Watchlist</div>
                  </th>
                  <th className="table-header-cell">
                    <div className="header-content">Notes</div>
                  </th>
                  <th
                    className="table-header-cell"
                    onClick={() => handleSortChange("name")}
                  >
                    <div className="header-content">Name</div>
                  </th>
                  {dummyHeaderArray.map((header, index) => (
                    <th key={index} className="table-header-cell">
                      <div className="header-content">{header}</div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {students
                  .filter((student) => {
                    if (selectedFilter === "all") return true;
                    if (selectedFilter === "atRisk0to20")
                      return (
                        student.readingScore !== undefined &&
                        student.readingScore <= 20
                      );
                    if (selectedFilter === "atRisk21to40")
                      return (
                        student.readingScore !== undefined &&
                        student.readingScore > 20 &&
                        student.readingScore <= 40
                      );
                    return true;
                  })
                  .map((student) => (
                    <SENWatchlistTableRow
                      readingScores={readingScores}
                      key={student.id}
                      student={student}
                      teachers={teachers}
                      teacherid={teacherid}
                      className={""}
                      setSetName={setSetName}
                      setName={setName}
                      currentStudentId={currentStudentId}
                      setCurrentStudentId={setCurrentStudentId}
                      dummyHeaderArray={dummyHeaderArray}
                      getReadingScoreClass={getReadingScoreClass}
                      handleSaveChanges={handleSaveChanges}
                      handleShowDetailsOfSetReceivedModal={
                        handleShowDetailsOfSetReceivedModal
                      }
                      handleShowSencoSupportPlanModal={
                        handleShowSencoSupportPlanModal
                      }
                      handleShowPlaceOnContinuumModal={
                        handleShowPlaceOnContinuumModal
                      }
                      handleShowLiteracyModal={handleShowLiteracyModal}
                      handleShowReadingScoreModal={handleShowReadingScoreModal}
                      handleShowEalModal={handleShowEalModal}
                      handleShowSetModal={handleShowESetModal}
                      handleShowAttendanceAffectingScoresModal={
                        handleShowAttendanceAffectingScoresModal
                      }
                      handleShowAdditionalNeedsModal={
                        handleShowAdditionalNeedsModal
                      }
                      handleShowPriorityConcernsModal={
                        handleShowPriorityConcernsModal
                      }
                      handleShowClassroomSupportPlanModal={
                        handleShowClassroomSupportPlanModal
                      }
                      handleShowSencoAdditionalNeedsModal={
                        handleShowSencoAdditionalNeedsModal
                      }
                      handleShowSetSetNameModal={handleShowSetSetNameModal}
                      handleShowSencoEalModal={handleShowSencoEalModal}
                      readingScoreNotes={readingScoreNotes}
                      setReadingScoreNotes={setReadingScoreNotes}
                      literacyObservations={literacyObservations}
                      additionalNeeds={additionalNeeds}
                      eal={eal}
                      set={set}
                      attendanceAffectingScores={attendanceAffectingScores}
                      dataVersion={dataVersion}
                    />
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
        <LiteracyObservationsModal
          show={showLiteracyModal}
          handleClose={handleCloseLiteracyModal}
          studentName={currentStudentName}
          literacyObservations={literacyObservations}
          setLiteracyObservations={setLiteracyObservations}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          getReport={getSencoReportByStudentId}
          upsertReport={upsertSencoReport}
        />
        <ReadingScoreNotesModal
          show={showReadingScoreModal}
          handleClose={handleCloseReadingScoreModal}
          studentName={currentStudentName}
          readingScoreNotes={readingScoreNotes}
          setReadingScoreNotes={setReadingScoreNotes}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          getReport={getSencoReportByStudentId}
          upsertReport={upsertSencoReport}
        />
        <AdditionalNeedsModal
          show={showAdditionalNeedsModal}
          handleClose={handleCloseAdditionalNeedsModal}
          studentName={currentStudentName}
          additionalNeeds={additionalNeeds}
          setAdditionalNeeds={setAdditionalNeeds}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          getReport={getSencoReportByStudentId}
          upsertReport={upsertSencoReport}
        />
        <DetailsOfSetReceivedModal
          show={showDetailsOfSetReceivedModal}
          handleClose={handleCloseDetailsOfSetReceivedModal}
          studentName={currentStudentName}
          setReceived={setReceived}
          setSetReceived={setSetReceived}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <PriorityConcernsModal
          show={showPriorityConcernsModal}
          handleClose={handleClosePriorityConcernsModal}
          studentName={currentStudentName}
          priorityConcerns={priorityConcerns}
          setPriorityConcerns={setPriorityConcerns}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <SencoSupportPlanModal
          show={showSencoSupportPlanModal}
          handleClose={handleCloseSencoSupportPlanModal}
          studentName={currentStudentName}
          sencoSupportPlan={sencoSupportPlan}
          setSencoSupportPlan={setSencoSupportPlan}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <PlaceOnContinuumModal
          show={showPlaceOnContinuumModal}
          handleClose={handleClosePlaceOnContinuumModal}
          studentName={currentStudentName}
          placeOnContinuum={placeOnContinuum}
          setPlaceOnContinuum={setPlaceOnContinuum}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <ClassroomSupportPlanModal
          show={showClassroomSupportPlanModal}
          handleClose={handleCloseClassroomSupportPlanModal}
          studentName={currentStudentName}
          classroomSupportPlan={classroomSupportPlan}
          setClassroomSupportPlan={setClassroomSupportPlan}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <SencoAdditionalNeedsModal
          show={showSencoAdditionalNeedsModal}
          handleClose={handleCloseSencoAdditionalNeedsModal}
          studentName={currentStudentName}
          sencoAdditionalNeeds={sencoAdditionalNeeds}
          setSencoAdditionalNeeds={setSencoAdditionalNeeds}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <SetSencoEalModal
          show={showSencoEalModal}
          handleClose={handleCloseSencoEalModal}
          studentName={currentStudentName}
          sencoEal={sencoEal}
          setSencoEal={setSencoEal}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          teacherid={teacherid}
          callClassName={callClassName}
          setName={setName}
        />
        <ConfirmationModal
          show={showConfirmationModal}
          handleClose={handleCloseConfirmationModal}
          studentName={currentStudentName}
          handleConfirmChange={handleConfirmChange}
          handleSaveChanges={handleSaveChanges}
        />
        <SetEalModal
          show={showEalModal}
          handleClose={handleCloseEalModal}
          studentName={currentStudentName}
          eal={eal}
          setEal={setEal}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
        />
        <SetSetNameModal
          show={showSetSetNameModal}
          handleClose={handleCloseSetSetModal}
          studentName={currentStudentName}
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
          setName={setName}
          setSetName={setSetName}
          teacherid={teacherid}
        />
        <SetSetModal
          show={showSetModal} // Correct the prop name
          handleClose={handleCloseSetModal} // Correct the close handler
          studentName={currentStudentName}
          set={set} // Correct state variable for SET
          setSet={setSet} // Correct setter function
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
        />
        <SetAttendanceAffectingScoresModal
          show={showAttendanceAffectingScoresModal} // Correct the prop name
          handleClose={handleCloseAttendanceAffectingScoresModal} // Correct the close handler
          studentName={currentStudentName}
          attendanceAffectingScores={attendanceAffectingScores} // Correct state variable for SET
          setAttendanceAffectingScores={setAttendanceAffectingScores} // Correct setter function
          handleSaveChanges={handleSaveChanges}
          currentStudentId={currentStudentId}
        />
      </Col>
    </Row>
  );
}

export default SENWatchlistTable;
